import { render, staticRenderFns } from "./CategoryProportion.vue?vue&type=template&id=718025a1&scoped=true"
import script from "./CategoryProportion.vue?vue&type=script&lang=ts"
export * from "./CategoryProportion.vue?vue&type=script&lang=ts"
import style0 from "./card.less?vue&type=style&index=0&id=718025a1&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718025a1",
  null
  
)

export default component.exports